module.exports = __webpack_public_path__ + "img/NardineGerges.e81e4203.jpg";